import React from "react";
import MenuGrid from "../MenuGrid";

const SECTIONS = [
  {
    title: "CxP",
    items: [
      { label: "Compras",                     icon: "fas fa-money-check-alt",     href: "/ListadoComprasCXP",                  key: "cxp.compras.ver" },
      { label: "Abonos Proveedores",          icon: "fas fa-dollar-sign",         href: "/ListadoAbonosProveedores",           key: "cxp.abonos.ver" },
      { label: "Estado Cuenta Proveedores",   icon: "fas fa-file-invoice-dollar", href: "/EstadoCuentaCXP",                    key: "cxp.estadoCuenta.ver" },
      { label: "Devoluciones",                icon: "fas fa-undo-alt",            href: "/ListadoDevolucionesProveedoresAdmin", key: "cxp.devoluciones.ver" },
    ],
  },
  // {
  //   title: "Maquileros",
  //   items: [
  //     { label: "Notas Maquileros",          icon: "fas fa-money-check-alt",     href: "/ListadoNotasCXP",            perm: "menu_adminCxP" },
  //     { label: "Abonos Maquileros",         icon: "fas fa-dollar-sign",         href: "/ListadoAbonosMaquileros",    perm: "menu_adminCxP" },
  //     { label: "Estado Cuenta Maquileros",  icon: "fas fa-file-invoice-dollar", href: "/EstadoCuentaMaq",            perm: "menu_adminCxP" },
  //     { label: "Anticipos Maquileros",      icon: "fas fa-dollar-sign",         href: "/ListadoAnticiposProveedores", perm: "menu_adminCxP" },
  //     { label: "Aplicar Faltantes",         icon: "fas fa-dollar-sign",         href: "/ListadoFaltantesProveedores", perm: "menu_adminCxP" },
  //   ],
  // },
];

function BotonesCXP() {
  return (
    <MenuGrid
      title="CxP"
      subtitle="Cuentas por pagar a proveedores"
      icon="fas fa-money-check-alt"
      accent={{ color: "#f43f5e", bg: "#fff1f2" }}
      modulo="cxp"
      sections={SECTIONS}
    />
  );
}

export default BotonesCXP;
